import GameCard from "./GameCard";

class PathGameCard extends GameCard{
    constructor(isLucky, pathID) {
        super(isLucky);
        this.pathID = pathID;
    }
}

export default PathGameCard;